<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.5 33H30C31.6569 33 33 31.6569 33 30V6C33 4.34315 31.6569 3 30 3H25.5" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.5 33H6C4.34315 33 3 31.6569 3 30V6C3 4.34315 4.34315 3 6 3H10.5" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 24L27 18L21 12" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M27 18H9" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>